<template>
  <a-form-model ref="form" :model="form.data" :rules="form.rules">
    <a-form-model-item label="税费名称">
      <a-input v-model="form.data.taxType"/>
    </a-form-model-item>
    <a-form-model-item label="税率">
      <a-input v-model="form.data.rate"/>
    </a-form-model-item>
    <a-form-model-item label="国家/地区">
      <a-input v-model="form.data.area"/>
    </a-form-model-item>
    <a-form-model-item label="描述">
      <a-input v-model="form.data.taxDesc"/>
    </a-form-model-item>
    <a-form-model-item>
      <a-space>
        <a-button type="primary" v-if="!taxId" @click="onAdd">创建</a-button>
        <a-button type="primary" v-if="taxId" @click="onUpdate">更新</a-button>
        <a-button @click="onCancel">{{ '取消' }}</a-button>
      </a-space>
    </a-form-model-item>
  </a-form-model>
</template>

<script>
import {
  _updateTax,
  _addTax,
  _getTaxDetail,
} from '@/api/websiteTaxApi'
import { _queryStory } from '@/api/websiteStoryApi';

async function onAdd() {
  const result = await _addTax({
    area: this.form.data.area,
    tax_type: this.form.data.type,
    rate: this.form.data.rate,
    tax_desc: this.form.data.desc,
  })
  if (result) {
    if (this.onSubmitHandler) {
      this.$message.success('添加成功')
      this.onSubmitHandler()
    }
  } else {
    this.$message.error('更新失败，可能已存在相同的标签名')
    this.onSubmitHandler()
  }
}

async function onUpdate() {
  this.$refs.form.validate(async (valid) => {
    if (valid) {
      const result = await _updateTax(this.goodsTagId, {
        area: this.form.data.area,
        rate: this.form.data.rate,
        tax_type: this.form.data.desc,
        tax_desc: this.form.data.type,
      })
      if (result) {
        if (this.onSubmitHandler) {
          this.$message.success('更新成功')
          this.onSubmitHandler()
        }
      } else {
        this.$message.success('更新失败')
        this.onSubmitHandler()
      }
    }
  })
}

async function getTaxDetail() {
  const result = await _getTaxDetail(this.taxId);
  if (result) {
    this.form.data.taxType = result.taxType;
    this.form.data.taxDesc = result.taxDesc;
    this.form.data.area = result.area;
    this.form.data.rate = result.rate;
  }
}

function onCancel() {
  if (this.onCancelHandler) {
    this.onCancelHandler();
  }
}

export default {
  name: 'TaxEdit',
  props: {
    taxId: String,
    onSubmitHandler: Function,
    onCancelHandler: Function,
  },
  watch: {
    TaxId() {
      if (this.taxId) {
        _getTaxDetail(this.taxId)
      }
    },
  },
  methods: {
    onAdd,
    onUpdate,
    onCancel,
    getTaxDetail
  },
  data() {
    return {
      form: {
        data: {
          taxType: '',
          rate: 0,
          taxDesc: '',
          area: ''
        },
        title: '',
      },
    }
  },
  async created() {
    console.log(this.taxId)
    if (this.taxId) {
      await this.getTaxDetail();
    }
  },
}
</script>
